export default class Event {
  constructor(element) {
    this.$el = $(element)
    this.$container = this.$el.parents('.events__wrap')
    this.$eventTriggers = this.$container.find('.event-item')
    this.$eventCards = this.$container.find('.event-card')
    this.init();
  }

  init() {
    const {$el, $eventTriggers, $eventCards, $container} = this
    $el.on('click', function (e) {
      if ($(this).hasClass('active')) {
        if (window.innerWidth < 769) {
          $eventTriggers.removeClass('active')
          $eventCards.removeClass('active')
        }
        return
      }
      $eventTriggers.removeClass('active')
      $eventCards.removeClass('active')
      $(this).addClass('active')
      const id = $(this).data('event-id')
      $container.find(`[data-id = ${id}]`).addClass('active')
    })
  }
}
